export default "__VITE_PUBLIC_ASSET__0b8567e0__"